<template>
	<el-table
		v-bind:data="categoryType"
		:show-header="false"
		row-key="id"
		@row-click="selectRow"
		:expand-row-keys="expand"
		empty-text="No articles read"
		style="width: 100%">

		<!-- Expandable article viewer -->
		<el-table-column type="expand">
			<template slot-scope="scope">
				<ArticleAnalysis
					:category="scope.row.id"
					:article="scope.row.article">
				</ArticleAnalysis>
			</template>
		</el-table-column>

		<!--  -->
		<el-table-column width="50">
			<template slot-scope="scope">
				<div class="complete">
					<i v-if="scope.row.article.length == scope.row.content.length"
						class="el-icon-success"></i>

					<el-progress class="complete" type="circle"
						:percentage="100.0 * scope.row.article.length / scope.row.content.length"
						:width="30"
						color="#833e93"
						:show-text="false">
					</el-progress>
				</div>
				<!-- <img class="article-icon"
					:src="getArticleImage(scope.row.article[0].id)"> -->
			</template>
		</el-table-column>

		<el-table-column prop="title" width="250">
			<template slot-scope="scope">
				<div style="line-height:16px">
					<strong>{{ getContentKey('category', scope.row.id, 'title') }}</strong><br>
				</div>
			</template>
		</el-table-column>

		<el-table-column width="200">
			<template slot-scope="scope">
					<span v-if="scope.row.article.length == scope.row.content.length">
						Read all {{ scope.row.content.length}} articles
					</span>
					<span v-else>
						Read {{ scope.row.article.length }} Article{{ scope.row.article.length > 1 ? 's' : '' }}
					</span>
			</template>
		</el-table-column>

		<el-table-column>
			<template slot-scope="scope">
				Last read<strong>&nbsp;{{ getContentKey('article', scope.row.last.type.split(':')[1], 'title') }}&nbsp;</strong>
					on<strong>&nbsp;{{ formatDate(scope.row.last.created) }}</strong>
			</template>
		</el-table-column>

		<!-- <el-table-column>
			<template slot-scope="scope">
				<DateRange :row="scope.row" timeKey="created"></DateRange>
			</template>
		</el-table-column> -->

	</el-table>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ArticleAnalysis from './Analysis'
import CardTable from '../component/table'

export default {
	name: 'patient-article-card-table',
	extends: CardTable,

	props: {
		patient: {
			type: Object,
			required: true
		},
		article: {
			type: Array
		}
	},

	data() {
		return {
			edit: false,
			expand: []
		}
	},

	mounted() {
		var missing = Object.keys(this.articleMap).filter((id) => (! this.getContent('article', id)))
		if (missing.length > 0)
			this.loadContent({ type: 'article', id: missing })
	},

	watch: {
		articleMap() {
			var missing = Object.keys(this.articleMap).filter((id) => (! this.getContent('article', id)))
			if (missing.length > 0) {
				this.loadContent({ type: 'article', id: missing })
			}
		}
	},

	methods: {
		...mapActions('content', [
			'loadContent'
		]),
		getArticleImage(article) {
			var content = this.getContent('article', article)
			// TEMP: if the profile articles have not been migrated to versioned
			if (! content)
				content = this.getContent('article', 'v1_' + article)
			if (! content)
				content = this.getContent('article', 'v0_' + article)
			if (content)
				return content.image
		}
	},

	computed: {
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),
		articleMap() {
			var map = {}
			this.article.forEach((article) => {
				let id = article.type.split(':')[1]
				if (! map[id])
					map[id] = []
				map[id].push(article)
			})
			return map
		},
		categories() {
			var categories = []
			if (Array.isArray(this.patient.profile))
				this.patient.profile.map((profile) => {
					let p = this.getContent('profile', profile)
					if (p && p.article) {
						categories.push.apply(categories, p.article.map((categoryId) =>
							this.getContent('category', categoryId)))
					}
				})
			return categories
		},
		categoryType() {
			if (! Array.isArray(this.categories))
				return []

			// For each category that the user's profile(s)
			return this.categories.filter((c) => c != null).map((category) => {
				let c = {
					id: category.id,
					content: category.article,
					last: category.article,
					// Go to each article in the category content object
					article: (category.article || [])
						.map((article) => ({
							id: (article.match(/^v\d+_/)) ? article : ('v0_' + article),
							event: (this.articleMap[article] || this.articleMap['v0_' + article] || [])
						}))
						.filter((article) => (article.event != null && article.event.length > 0))
				}
				let last = null
				c.article.forEach((article) => {
					article.event.forEach((event) => {
						if (last == null || event.created > last.created)
							last = event
					})
				})
				c.last = last
				return c
			})
			.filter((category) => category.article.length > 0)
		},
		articleIds() {
			return Object.keys(this.articleMap)
		}
	},

	components: {
		ArticleAnalysis
	}
}
</script>

<style lang="scss" scoped>
.article-icon {
	width: 32px;
	height: 32px;
	float: left;
}
.complete {
	float: left;
	position: relative;

	i {
		color: #833e93;
		position: absolute;
		z-index: 10;
		font-size: 24px;
		left: 3px;
		top: 3px;
	}
}
</style>
